<template>
  <div
    v-if="consents.length"
    class="campaign-consents-container"
    data-pptr="consents"
  >
    <div
      v-for="(group, groupIndex) in consentGroups"
      :key="`consent-group-${groupIndex}`"
      class="consent-group"
    >
      <div v-if="group.title" class="consent-group-title headline-s">
        {{ group.title }}
      </div>

      <BaseCampaignConsentItem
        v-for="consent in group.items"
        :key="consent.key"
        :consent="consent"
        :answer="answerOf(consent.key)"
        :error="isInvalid(consent.key)"
        :serverReason="serverReasonOf(consent.key)"
        @change="onChange"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BaseCampaignConsentItem from '@/components/base/BaseCampaignConsentItem.vue'

export default {
  name: 'BaseCampaignConsents',

  components: {
    BaseCampaignConsentItem,
  },

  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },

  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorKeys: {
      type: Array,
      default: () => [],
    },
    serverErrors: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    ...mapState({
      campaign: state => state.campaign.current,
    }),

    // Keep the order returned by the API (already sorted by sort_order)
    consents() {
      return this.campaign?.data?.consents ?? []
    },

    // Consecutive items sharing the same group_title are shown
    // under a single heading
    consentGroups() {
      return this.consents.reduce((groups, consent) => {
        const title = consent.group_title ?? null
        const lastGroup = groups[groups.length - 1]

        if (lastGroup && lastGroup.title === title) {
          lastGroup.items.push(consent)

          return groups
        }

        groups.push({ title, items: [consent] })

        return groups
      }, [])
    },

    serverReasonByKey() {
      return (this.serverErrors ?? []).reduce((reasons, item) => {
        reasons[item?.key] = item?.reason ?? null

        return reasons
      }, {})
    },
  },

  methods: {
    answerOf(key) {
      return this.modelValue?.[key] ?? false
    },

    isInvalid(key) {
      return this.error && this.errorKeys.includes(key)
    },

    serverReasonOf(key) {
      return this.serverReasonByKey[key] ?? null
    },

    onChange({ key, value }) {
      this.$emit('update:modelValue', {
        ...this.modelValue,
        [key]: value,
      })
    },
  },
}
</script>

<style lang="stylus" scoped>
.campaign-consents-container
  display: flex
  flex-direction: column
  gap: 24px

.consent-group
  display: flex
  flex-direction: column
  gap: 24px

.consent-group-title
  color: rgba(#000000, 0.85)
</style>
